module.exports = __webpack_public_path__ + "static/media/splash-quote-thumb.9b6d4e2e.png";